import { render } from "./HeadingAnalyticsPerfection.vue?vue&type=template&id=454d0740&scoped=true"
import script from "./HeadingAnalyticsPerfection.vue?vue&type=script&lang=js"
export * from "./HeadingAnalyticsPerfection.vue?vue&type=script&lang=js"

import "@/css/components/heading-analytics-perfection.css?vue&type=style&index=0&id=454d0740&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454d0740"]])

export default __exports__